//* 组件库
import type { UiTableOption2 } from "various-ui";
//* 样式
import css from "../style/index.module.less";

export const useOptions = () => {
    //* 获取i18n
    const i18n = useI18n();

    return {
        //* 表格配置
        view: <UiTableOption2[]>[
            { name: i18n.t("Acting"), key: "effect_name", align: "center", sort: true },
            { "name": i18n.t("Regulation"), "key": "regulation_mode", "align": "center", "extra": true, "extra-name": css.checkboxs },
            { "name": i18n.t("Detail", 2), "key": "regulatory_detail", "align": "center", "extra": true, "extra-name": css.checkboxs },
            { name: i18n.t("Mechanism"), key: "mechanisms", align: "center" },
            { name: i18n.t("Target"), key: "target_name", align: "center", sort: true },
            { name: i18n.t("Residues", 1), key: "aminos", align: "center", sort: true },
            { name: i18n.t("Reference", 2), key: "references", align: "center", sort: true },
            { name: i18n.t("Score"), key: "score", align: "center", sort: true },
        ],
    };
};
